/*
  Formulaires d'inscription vers la plateforme (app.swander.fr), à la place de Klaviyo.
  Chaque formulaire porte data-sw-optin="newsletter" ou data-sw-optin="freebie" avec data-freebie="<clé>",
  un champ email, un champ name facultatif, le champ piège « website » (laissé vide par un humain),
  un élément [data-sw-message] et le message de succès dans data-sw-success.

  Contexte d'arrivée envoyé avec l'inscription (page Acquisition de l'admin) : la page du formulaire, son
  référent et ses UTM. Quand le visiteur a accepté la mesure d'audience (API de confidentialité Shopify),
  le navigateur garde aussi son premier et son dernier contact venus de l'extérieur.
*/
(function () {
  if (window.swOptinLoaded) return;
  window.swOptinLoaded = true;

  var API = 'https://app.swander.fr/api/';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var UTM_KEYS = ['source', 'medium', 'campaign', 'content', 'term'];
  var FIRST = 'sw_first_touch';
  var LAST = 'sw_last_touch';

  function currentTouch() {
    var utm = {};
    try {
      var params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach(function (k) {
        var v = params.get('utm_' + k);
        if (v) utm[k] = v.slice(0, 200);
      });
    } catch (e) {}
    var ref = document.referrer && document.referrer.indexOf(window.location.host) === -1 ? document.referrer : '';
    return { at: new Date().toISOString(), landing: window.location.href.slice(0, 500), referrer: ref.slice(0, 500), utm: utm };
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
    } catch (e) {
      return false;
    }
  }

  function remember() {
    if (!analyticsAllowed()) return;
    try {
      var touch = currentTouch();
      var external = touch.referrer || Object.keys(touch.utm).length > 0;
      if (!window.localStorage.getItem(FIRST)) window.localStorage.setItem(FIRST, JSON.stringify(touch));
      if (external) window.localStorage.setItem(LAST, JSON.stringify(touch));
    } catch (e) {}
  }

  function context() {
    var here = currentTouch();
    var first = null;
    var last = null;
    try {
      first = JSON.parse(window.localStorage.getItem(FIRST) || 'null');
      last = JSON.parse(window.localStorage.getItem(LAST) || 'null');
    } catch (e) {}
    return { first: first || last || here, last: last || here, page: here };
  }

  function bind(form) {
    if (form.getAttribute('data-sw-bound')) return;
    form.setAttribute('data-sw-bound', '1');
    var kind = form.getAttribute('data-sw-optin') === 'freebie' ? 'freebie' : 'newsletter';
    var message = form.querySelector('[data-sw-message]');
    var button = form.querySelector('[type="submit"]');

    function say(text, isError) {
      if (!message) return;
      message.textContent = text || '';
      message.style.display = text ? '' : 'none';
      message.classList.toggle('is-error', !!isError);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = ((form.elements.email && form.elements.email.value) || '').trim();
      if (!EMAIL_RE.test(email)) {
        say('Indique une adresse email valide.', true);
        return;
      }
      var body = { email: email, website: form.elements.website ? form.elements.website.value : '', acquisition: context() };
      if (form.elements.name) body.name = form.elements.name.value.trim();
      if (kind === 'freebie') {
        body.freebie = form.getAttribute('data-freebie') || '';
        try {
          body.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {}
      }
      if (button) button.disabled = true;
      say('', false);
      fetch(API + kind, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          form.reset();
          form.classList.add('is-sent');
          say(form.getAttribute('data-sw-success') || 'Merci, ton inscription est confirmée.', false);
        })
        .catch(function () {
          say('L’inscription n’a pas abouti. Réessaie dans un instant.', true);
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    });
  }

  function init() {
    remember();
    var forms = document.querySelectorAll('form[data-sw-optin]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  // La bannière de cookies peut répondre après le chargement : on retient le contact à ce moment-là.
  document.addEventListener('visitorConsentCollected', remember);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
